module.exports = __webpack_public_path__ + "img/cleaner_arrival_white-icon.6b4532f6.svg";